import { envs } from '@/app/lib/config/envs';
import GithubOctocatIcon from '@/app/ui/assets/icons/github-octocat-icon';
import React from 'react';
import type { ButtonProps } from 'tailframes-components/components/button';
import { Button } from '@/app/ui/components/atoms/button';

interface Props extends Omit<ButtonProps, 'children'> {
  iconClassName?: string;
}

export default function GithubButton({ iconClassName, ...props }: Props) {
  return (
    <Button variant='text-default' startAdornment={<GithubOctocatIcon className={iconClassName} />} href={envs.githubTailframesComponentsUrl} {...props}>
      Github
    </Button>
  );
}
